require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-unterfrauenhaid.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-unterfrauenhaid");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-unterfrauenhaid!./.cache/json/betreuungseinrichtungen-oberpullendorf-unterfrauenhaid.json
// module id = 995
// module chunks = 231608221292675